export const DEFAULT_OFFERS_DATA = {
  breadcrumbs: [],
  newbuildings: [],
  similarNewbuildings: [],
  seo: null,
  fullUrl: '',
  users: [],
  builder: null,
  newbuildingBuilderStats: [],
  total: 0,
  queryString: '',
  mapFullUrl: '',
  salesLeaderFullUrl: '',
  newbuildingIdsForBuildersPromoSlider: [],
};
